import React from 'react';
import { WizardCard } from './fdicChrome';

const DollarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" aria-hidden="true">
    <path d="M12 3v18M16 7a4 4 0 00-4-2c-2.5 0-4 1.3-4 3s1.5 2.7 4 3 4 1.3 4 3-1.5 3-4 3a4 4 0 01-4-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const fmtDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const Row = ({ label, value, valueClass = 'text-[#1a2b3c]' }) => (
  <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 last:border-b-0 gap-4">
    <span className="text-[13px] text-gray-500">{label}</span>
    <span className={`text-[15px] font-semibold text-right ${valueClass}`}>{value}</span>
  </div>
);

const Step2Financials = ({ data, onNext }) => (
  <WizardCard headerIcon={<DollarIcon />} headerLabel="Financials">
    <div className="px-5 pt-5 pb-2">
      <h2 className="font-serif text-[22px] text-[#1a2b3c]">Insured Finances</h2>
    </div>

    <div>
      <Row label="Support Number"   value={data.supportPhone} />
      <Row label="Available Amount" value={fmtMoney(data.availableAmount)} />
      <Row label="Insured Amount"   value={fmtMoney(data.insuredAmount)} valueClass="text-[#1f5c3a]" />
      <Row label="Date of Placed"   value={fmtDate(data.placedAt)} />
      <Row label="Date of Delivery" value={fmtDate(data.fundsDeliveredAt)} />
    </div>

    <div className="p-5">
      <button
        onClick={onNext}
        className="w-full bg-[#0b2740] hover:bg-[#12324f] text-white text-[13px] font-semibold tracking-[0.15em] uppercase py-4 rounded-md"
      >
        Final Verification
      </button>
    </div>
  </WizardCard>
);

export default Step2Financials;